"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBusinessClientParsedResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const ClientBusiness_1 = require("./ClientBusiness");
const AccountBusiness_1 = require("./AccountBusiness");
function transformBusinessClientParsedResponse(client) {
    return {
        id: client.id,
        businessId: client.business_id,
        accountId: client.account_id,
        userId: client.userid,
        clientBusiness: client.client_business && (0, ClientBusiness_1.transformClientBusinessParsedResponse)(client.client_business),
        accountBusiness: client.account_business && (0, AccountBusiness_1.transformAccountBusinessParsedResponse)(client.account_business),
    };
}
exports.transformBusinessClientParsedResponse = transformBusinessClientParsedResponse;
//# sourceMappingURL=BusinessClient.js.map